var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2933 27.5222C31.6839 27.9127 32.317 27.9127 32.7076 27.5222L44.4933 15.7364C44.8839 15.3459 45.517 15.3459 45.9076 15.7364L48.264 18.0929C48.6545 18.4834 48.6545 19.1165 48.264 19.5071L36.4782 31.2929C36.0877 31.6834 36.0877 32.3165 36.4782 32.7071L48.264 44.4929C48.6545 44.8834 48.6545 45.5165 48.264 45.9071L45.9076 48.2635C45.517 48.654 44.8839 48.654 44.4933 48.2635L32.7076 36.4777C32.317 36.0872 31.6839 36.0872 31.2933 36.4777L19.5076 48.2635C19.117 48.654 18.4839 48.654 18.0933 48.2635L15.7369 45.9071C15.3464 45.5165 15.3464 44.8834 15.7369 44.4929L27.5227 32.7071C27.9132 32.3165 27.9132 31.6834 27.5227 31.2929L15.7369 19.5071C15.3464 19.1165 15.3464 18.4834 15.7369 18.0929L18.0933 15.7364C18.4839 15.3459 19.117 15.3459 19.5076 15.7364L31.2933 27.5222Z",
    fill: "#1F375B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClose);
export default __webpack_public_path__ + "static/media/ico-close.a4cc432425a8fd54e1cada80633eb55a.svg";
export { ForwardRef as ReactComponent };